var map = {
	"./PTMPAY/index.ts": 9386,
	"./appQr/index.ts": 2259,
	"./cardafrica/index.ts": 7325,
	"./customInrQr/index.ts": 7778,
	"./customPay/index.ts": 2248,
	"./easypay/index.ts": 9655,
	"./indiaH5/index.ts": 1271,
	"./indiaH5Pay/index.ts": 5283,
	"./indiaQr/index.ts": 1671,
	"./indiaSpecial/index.ts": 8911,
	"./inrqrAnother/index.ts": 4982,
	"./jazzpay/index.ts": 2022,
	"./kaazPay/index.ts": 3788,
	"./metaPay/index.ts": 314,
	"./mpesa/index.ts": 6771,
	"./newIndiaQr/index.ts": 9687,
	"./newKaazPay/index.ts": 1212,
	"./newrmqr/index.ts": 6743,
	"./notSkipUpi/index.ts": 6515,
	"./orbitPay/index.ts": 6943,
	"./otherInrQr/index.ts": 8575,
	"./pkrpay/index.ts": 1852,
	"./pnbPay/index.ts": 7399,
	"./rmqr/index.ts": 7287,
	"./usdtbuy/index.ts": 3503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6315;